import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AUTH_ERROR_STATUS } from '../enums/auth-error-status';
import { ErrorModalService } from '@app/shared/modals/error-modal/error-modal.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {

  constructor(
    private errorModalService: ErrorModalService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse | any): Observable<any> => {
          let httpError = null;
          /* istanbul ignore else */
          if (error instanceof HttpErrorResponse && error.status in AUTH_ERROR_STATUS) {
            httpError = {
              statusCode: error.status,
              message: error.message,
              description: error.error.description || error.error.message || 'Undefined error description'
            };
          } else {
            if (error.networkError && error.networkError.statusCode === AUTH_ERROR_STATUS.UNAUTHORIZED) {
              httpError = {
                statusCode: error.networkError.statusCode,
                message: error.networkError.message,
                description: error.error.description || error.error.message || 'Undefined error description'
              };
            } else {
              return throwError(error);
            }
          }

          // do not display errors related to the error service
          /* istanbul ignore else */
          if (httpError && !error.message.includes('/api/error') && !error.message.includes('/auth/validate')) {
            this.errorModalService.showErrorModal(httpError);
          }

          return throwError(error);
        })
      );
  }
}
